import React, {useEffect} from 'react';

import usePlayer from './usePlayer';
import {CreateVideoOptions, Player} from './YoutubePlayerManager';


interface Props {
    elementId: string,
    options: CreateVideoOptions,
    onPlayerReady: (player: Player) => void,
}

const YoutubePlayer = ({elementId, onPlayerReady, options}: Props) => {
    const player = usePlayer(elementId, options);

    useEffect(() => {
        if (!player) {
            return;
        }

        onPlayerReady(player);
    }, [player, onPlayerReady]);
    return (<div id={elementId} />);
};

export default YoutubePlayer;
